import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";
import ProductsCheckTable from "../../components/Table/ProductsCheckTable";
import axios from "axios";
import { DatePicker, Input, Pagination, Select } from "antd";
import { Context } from "../../Context/Context";
// Pictures
import Buttons from "../../components/Buttons/Buttons";
import { Modal } from "../../components/Modal/Modal";
function AllProductsCheck() {
  const { lang } = useContext(Context);
  const navigate = useNavigate();
  const allSearchRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const env = process.env.REACT_APP_API;

  const token = JSON.parse(window.localStorage.getItem("token"));
  const categorySavedId = JSON.parse(window.localStorage.getItem("categoryId"));
  // Basic
  const [pageNum, setPageNum] = useState(
    JSON.parse(localStorage.getItem("productPageCheckNum")) || 1
  );
  const [pageSize, setPageSize] = useState(20);
  let filterRequest = {
    pageNumber: pageNum,
    pageSize: pageSize,
    sortingField: "id",
    sortDirection: "ASC",
  };
  localStorage.setItem("productPageCheckNum", JSON.stringify(pageNum));

  // Basic
  // Category get start
  const [categoryId, setCategoryId] = useState(categorySavedId || undefined);
  const [categoryList, setCategoryList] = useState([]);
  const onChange1 = (value) => {
    if (value === undefined) {
      window.localStorage.removeItem("categoryId");
      return setCategoryId(undefined);
    }
    setPageNum(1);
    setCategoryId(value);
    window.localStorage.setItem("categoryId", JSON.stringify(value));
  };

  const [isChecked, setIsChecked] = useState(false);

  const checkboxValue = "myCheckboxValue";

  const handleOnChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [selectedDate, setSelectedDate] = useState("");
  const [openCheckStatusModal, setOpenCheckStatusModal] = useState(false);

  const [checkProductsNumber, setCheckProductsNumber] = useState({
    count: 0,
    updatedAt: "",
  });

  // setresponseStatus
  const [responseStatus, setResponseStatus] = useState(false);

  React.useEffect(() => {
    axios
      .get(`${env}cabinet/v2/categories`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCategoryList(
          res.data.map((item) => ({
            value: item.id,
            label: item.categoryOz,
          }))
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Category get end

  // all change input start
  const [searchValue, setSearchValue] = useState(
    window.sessionStorage.getItem("searchAllCategory") || ""
  );
  const [renderList, setRenderList] = useState(
    JSON.parse(window.localStorage.getItem("renderProductCheckList")) || []
  );
  const [totalElements, setTotalElements] = React.useState(0);
  // // Result get post start
  // React.useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .post(`${env}cabinet/v2/all-products`, filterRequest, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       params: {
  //         catId: categoryId,
  //       },
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       setTotalElements(res.data.totalElements);
  //       setRenderList(res.data.listOfItems);
  //     })
  //     .catch((err) => {
  //       setRenderList([{ id: 1, title: "Ma'lumot yo'q" }]);
  //       if (err.response?.status === 500) {
  //         toast.error("Serverda xatoli bor !");
  //       } else if (err.response.status === 401) {
  //         window.localStorage.clear();
  //         window.sessionStorage.clear();
  //         window.location.reload();
  //       }
  //     });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [refOFD, pageNum, pageSize, categoryId]);
  // // Result get post end

  // New result get for uncheck products
  React.useEffect(() => {
    let params = {};
    if (categoryId === undefined) {
      params = {
        searchText: searchValue,
        categoryId: 0,
      };
    } else
      params = {
        categoryId: categoryId,
        inUse: isChecked,
        searchText: searchValue,
      };
    setLoading(true);
    axios
      .post(`${env}cabinet/v2/product/in-use`, filterRequest, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { ...params },
      })
      .then((res) => {
        setLoading(false);
        setTotalElements(res.data.totalElements);
        setRenderList(res.data.listOfItems);
      })
      .catch((err) => {
        setRenderList([{ id: 1, title: "Ma'lumot yo'q" }]);
        if (err.response?.status === 500) {
          toast.error("Serverda xatoli bor !");
        } else if (err.response.status === 401) {
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.reload();
        }
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum, pageSize, categoryId, isChecked, searchValue]);

  React.useEffect(() => {
    checkProductsNumberFunc();
  }, [categoryId, isChecked]);

  // const [unCheckEdData, setUnCheckedData] = React.useState(
  //   window.sessionStorage.getItem("checkTotalElCheck") || 0
  // );
  // React.useEffect(() => {
  //   axios
  //     .get(`${env}cabinet/v2/getuncheck_mxik`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((res) => {
  //       setUnCheckedData(res.data);
  //     })
  //     .catch((err) => {
  //       if (err.response.status === 401) {
  //         navigate("/");
  //         window.localStorage.clear();
  //         window.sessionStorage.clear();
  //         window.location.reload();
  //       }
  //     });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [refOFD]);

  window.localStorage.setItem(
    "renderProductCheckList",
    JSON.stringify(renderList)
  );
  window.localStorage.setItem("productTotalElCheck", totalElements);
  // window.sessionStorage.setItem("checkTotalElCheck", unCheckEdData);

  // Input value
  const handleAllCange = (evt) => {
    setPageNum(1);
    setSearchValue(evt.target.value);
    if (evt.target.value === "") {
      setLoading(false);
    } else {
      setLoading(true);
    }
  };

  // Pagination Start
  const onChange = (pageNumber, pageFullSize) => {
    setPageNum(pageNumber);
    setPageSize(pageFullSize);
  };

  const checkProducts = () => {
    if (!responseStatus) {
      if (!selectedDate) {
        toast.error(lang ? "Выберите дату" : "Sana tanlang");
        return;
      }

      if (selectedDate) {
        axios
          .get(`${env}cabinet/v2/check-all-products`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              date: selectedDate,
              categoryId: categoryId,
              inUse: isChecked,
            },
          })
          .then((res) => {
            toast.success(
              lang
                ? "Проверка продуктов началась успешно :)"
                : res.data || "Mahsulotlarni tekshirish tugadii :)"
            );
          })
          .catch((err) => {
            toast.error(err?.response?.data || err?.message);
          });
      }
      setOpenCheckStatusModal(false);
    }
  };

  const checkProductsNumberFunc = () => {
    axios
      .get(
        `${env}cabinet/v2/get/all-uncheck-mxik?categoryId=${
          categoryId || 0
        }&inUse=${isChecked}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCheckProductsNumber({
          count: res?.data?.count,
          updatedAt: res?.data?.updatedAt,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getResponseProcessStatus = () => {
    axios
      .get(`${env}cabinet/v2/get/processStatus`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setResponseStatus(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Pagination end
  return (
    <div className="">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="bg-white px-5 p-4 ">
        <div>
          <h2 className="font-bold text-[25px]">
            {lang ? "Список продуктов" : "Mahsulotlar ro'yxati"}
          </h2>
          <span className="text-slate-400">
            {totalElements} {lang ? "продуктов" : "mahsulotlar"}
          </span>
        </div>
        <div className="flex flex-col xl:flex-row justify-between mt-8 items-center">
          <div className="flex items-end justify-start gap-2">
            {" "}
            <label className="flex flex-col">
              <span className="text-slate-500 inline-block mb-1 pl-1">
                {lang
                  ? "Ключевое слово для поиска"
                  : "Qidirish uchun kalit so'z "}
              </span>
              <Input
                allowClear
                className="w-[350px]"
                value={searchValue}
                ref={allSearchRef}
                onChange={handleAllCange}
                size="large"
                placeholder={
                  lang
                    ? "Ключевое слово для поиска"
                    : "Qidirish uchun kalit so'z "
                }
              />
            </label>
            <label className="flex flex-col">
              <span className="text-slate-500 inline-block mb-1 pl-1">
                {lang ? "Выберите категорию" : "Kategoriya tanlang"}
              </span>
              <Select
                style={{ inlineSize: "350px" }}
                allowClear
                showSearch
                size="large"
                placeholder={lang ? "Выберите категорию" : "Kategoriya tanlang"}
                optionFilterProp="children"
                onChange={onChange1}
                value={categoryId}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={categoryList}
              />
            </label>
            <div className="flex items-center justify-center gap-2 mb-2">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleOnChange}
                value={checkboxValue}
                className="w-6 h-6"
                disabled={categoryId ? false : true}
              />
              <p>{isChecked ? "Ishlatilinayotgan" : "Ishlatilinmayotgan"}</p>
            </div>
          </div>

          <Buttons
            title={lang ? "Проверять" : "Tekshirish"}
            clicked={() => {
              setOpenCheckStatusModal(true);
              // checkProductsNumberFunc();
              getResponseProcessStatus();
            }}
          />
        </div>
      </div>
      <div className="px-5">
        <h2 className="font-semibold text-[18px] mt-2">
          {lang ? "Продукты" : "Mahsulotlar"} ({totalElements}{" "}
          {lang ? "шт" : "ta"}){" "}
        </h2>
        <h2 className="font-semibold text-[18px] mt-1">
          {lang ? "Непроверенные продукты" : "Tekshirilmagan mahsulotlar"} (
          {checkProductsNumber.count} {lang ? "шт" : "ta"})
        </h2>
        <h2 className="font-semibold text-[18px] mt-1">
          {lang ? "Непроверенные продукты" : "Oxirgi yangilanish"} (
          {checkProductsNumber.updatedAt || "-"} {lang ? "da" : "da"})
        </h2>
      </div>
      <div className="mt-4 px-5 w-full">
        <ProductsCheckTable loading={loading} renderList={renderList} />
      </div>
      <div className="flex justify-center py-5">
        <Pagination
          showQuickJumper
          defaultCurrent={pageNum}
          defaultPageSize={pageSize}
          total={totalElements || renderList.length > 0 ? totalElements : 1}
          onChange={onChange}
        />
      </div>

      <Modal
        className={"w-[30%] overflow-y-auto max-h-[85%]"}
        isVisible={openCheckStatusModal}
        onClose={() => {
          setOpenCheckStatusModal(false);
          setSelectedDate("");
        }}
      >
        <div className="flex flex-col gap-5">
          <h2 className="text-center text-[20px] font-semibold ">
            {lang
              ? "Проверить статус продуктов"
              : "Mahsulotlar holatini tekshirish"}
          </h2>
          <DatePicker
            locale={"uz-latn"}
            className="w-[100%]"
            placeholder={lang ? "Выберите дату" : "Sana tanlang"}
            onChange={(value) => {
              setSelectedDate(value?.format("YYYY-MM-DD"));
            }}
          />
        </div>

        <div
          className={`${
            responseStatus ? "bg-yellow-300" : "bg-green-300"
          } rounded-md text-center p-3 mt-2`}
        >
          {responseStatus ? "Ishlayapti teginma" : "Bosaver gazini"}
        </div>
        <div className="bg-blue-100 p-3 rounded-md text-center mt-2">
          <h2 className="font-semibold">
            {lang
              ? `Количество непроверенных продуктов: ${checkProductsNumber?.count} шт`
              : `Tekshirilmagan mahsulotlar soni: ${checkProductsNumber?.count} ta`}
          </h2>
          {checkProductsNumber?.updatedAt && (
            <span className="text-sm text-slate-500">
              {lang ? "Последнее обновление:" : "Oxirgi yangilanish:"}{" "}
              {checkProductsNumber?.updatedAt}
            </span>
          )}
        </div>
        <Buttons
          extraSty={`h-[45px] w-[100%] mt-5 ${
            responseStatus ? "disabled" : ""
          }`}
          bg={"blue"}
          title={lang ? "Проверить" : "Tekshirish"}
          clicked={() => checkProducts()}
        />
      </Modal>
    </div>
  );
}

export default AllProductsCheck;
